module.exports = "/assets/about/success/brief.png?HQAX4Rk";